import { render, staticRenderFns } from "./shortenerLink.vue?vue&type=template&id=53cff6dc&"
import script from "./shortenerLink.vue?vue&type=script&lang=js&"
export * from "./shortenerLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports